import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Loading } from '../../components/Loading';
import ErrorMessageBox from '../../components/ErrorMessageBox';
import { READING_TYPE_LIST } from '../../../lib/const';
import SummaryActivityType from './SummaryActivityType';
import { SummaryCategory } from './SummaryCategory';
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from 'utils/api/Api';

export const UserHistoryByYear = ({year})=>{
    const auth = useSelector(state => state.auth);
    
    const { data:readingYearHistory, isLoading, isError, error } = useQuery({
        queryKey:['user/history/year', year],
        queryFn:()=>Api.get(`/api/user/result/${year}/history`),
        refetchOnMount:'always',
    });

    function renderList(){
        if(readingYearHistory?.data?.list===null || readingYearHistory?.data?.list.length===0){
            return <div className="no_data"><p>독서활동 내역이 없습니다.</p></div>
        } 

        let lastMonth = '';
        let renderHtml = [];
        let renderMonthBooks = [];
        readingYearHistory?.data?.list.forEach((reading, key)=>{
            const tmpMonth = reading.createdAt.substring(5, 7)
            if(lastMonth !== tmpMonth){
                if(renderMonthBooks.length!==0){
                    renderHtml.push(
                        <div className="book_list" key={key}>
                            <ul className="clear">
                                {renderMonthBooks}
                            </ul>
                        </div>
                    );
                    renderMonthBooks = [];
                }
                renderHtml.push(<h5 className="month" key={key+'_title'}><span>{tmpMonth}월</span></h5>);
            }
            lastMonth = tmpMonth;

            if(reading.type==='userbook'){
                renderMonthBooks.push(
                <li key={key+'_'+reading.id}>
                    <div className="book_wrap">
                        <div className="book_cover">
                            <div className="book_inner">
                                {reading.image!==null && reading.image!=='' &&
                                    <img src={(null!==reading.image &&  reading.image.startsWith('http://') )?`${reading.image}`:reading.image} alt="" />
                                }
                                { (reading.image===null || reading.image==='') && <img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_cover_no_image.jpg`} alt="표지 없음"/> }
                                {reading.isApple && <div className="apple"></div> }
                                
                            </div>
                        </div>
                        <div className="book_info">
                            <div className="history">
                                <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/userbook/episode/view/${reading.activityId}`}>
                                    <i className="fa-solid fa-pencil"></i> {READING_TYPE_LIST[reading.type]}
                                    <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                </Link>
                            </div>
                            <p className="title">{reading.title}</p>
                            <p className="writer">{auth.name}</p>
                            <p className="pb_company">나도작가다</p>
                        </div>
                    </div>
                </li>
                );
            } else if (reading.type==='dongwha') {
                renderMonthBooks.push(
                    <li key={key+'_'+reading.id}>
                        <div className="book_wrap">
                            <div className="book_cover">
                                <div className="book_inner">
                                {reading.image==='' &&
                                    <img src={`${process.env.PUBLIC_URL}/static/images/dongwha/dongwha_cover.jpg`} alt="동화서당" />
                                }
                                {reading.isApple && <div className="apple"></div> }
                                </div>
                            </div>
                            <div className="book_info">
                                <div className="history">
                                    <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/donghwa/story/${reading.activityId}`}>
                                        <i className="fa-solid fa-paintbrush"></i>{READING_TYPE_LIST[reading.type]}
                                        <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                    </Link>
                                </div>
                                <p className="title">{reading.name}</p>
                                <p className="writer">{auth.name}</p>
                                <p className="pb_company">동화서당</p>
                            </div>
                        </div>
                    </li>
                );
            }else{
                renderMonthBooks.push(
                    <li key={key+'_'+reading.id}>
                        <div className="book_wrap">
                            <Link to={`/${window.schoolCode}/book/${reading.isbn}`} >
                                <div className="book_cover">
                                    <div className="book_inner">
                                        <img src={(null!==reading.image &&  reading.image.startsWith('http://') )?`${reading.image}`:reading.image} alt="" />
                                        {reading.isApple && <div className="apple"></div> }
                                    </div>
                                </div>
                            </Link>
                            <div className="book_info">
                                <div className="history">
                                    { 'report'===reading.type &&
                                        <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/book/${reading.isbn}/bookreport/view/${reading.activityId}`}>
                                            <i className="icon fas fa-edit"></i> {READING_TYPE_LIST[reading.type]}
                                             <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </Link>
                                    }
                                    { 'picture'===reading.type &&
                                        <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/book/${reading.isbn}/picture/view/${reading.activityId}`}>
                                            <i className="icon far fa-image"></i> {READING_TYPE_LIST[reading.type]}
                                            <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </Link>
                                    }
                                    { 'photo'===reading.type &&
                                        <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/book/${reading.isbn}/photo/view/${reading.activityId}`}>
                                            <i className="icon far fa-image"></i> {READING_TYPE_LIST[reading.type]} 독서사진
                                            <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </Link>
                                    }
                                    { 'youtube'===reading.type &&
                                        <Link className={`type info ${reading.type}`}  to={`/${window.schoolCode}/book/video/view/${reading.activityId}`}>
                                            <i className="icon fab fa-youtube"></i> {READING_TYPE_LIST[reading.type]}
                                            <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </Link>
                                    }
    
                                    { 'meeting'===reading.type &&
                                        <div className="info">
                                            <i className="fa-solid fa-puzzle-piece"> </i>{READING_TYPE_LIST[reading.type]}
                                            <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </div>
                                    }
                                    { 'quiz'===reading.type &&
                                        <div className={`type info ${reading.type}`}>
                                            <i className="fa-solid fa-circle-question"></i> {READING_TYPE_LIST[reading.type]}
                                            <span>{reading.createdAt.substring(5, 10).replace(/-/gi, '.')}</span>
                                        </div> 
                                    }
                                </div>
                                <p className="title">{reading.title}</p>
                                <p className="writer">{reading.author}</p>
                                <p className="pb_company">{reading.publisher}</p>
                            </div>
                        </div>
                    </li>
                );
            }
        });//end loop
        
        if(renderMonthBooks.length!==0){
            renderHtml.push(
                <div className="book_list" key="last_books">
                    <ul className="clear">
                        {renderMonthBooks}
                    </ul>
                </div>
            );
            renderMonthBooks = [];
        }
        
        return renderHtml;
    }

    
    
    if( isLoading ) return <Loading />;
    if( isError ) return <ErrorMessageBox message={ createFetchErrorMessage(error).message}  />;
    
    return (
        <div className="history_wrap" style={{display:'block'}} >
            <div className="last_year_status">
                {readingYearHistory?.data?.summary!==null &&
                <div className="last_year_status">
                    <div className="row">
                        <SummaryActivityType summary={readingYearHistory?.data?.summary} />
                        <SummaryCategory category={readingYearHistory?.data?.summary.category_general2} />
                    </div>
                </div>
                    }
            </div>
            {renderList()}
        </div>
    );
};